import { render, staticRenderFns } from "./epmallcart.vue?vue&type=template&id=c2e7bff6"
import script from "./epmallcart.vue?vue&type=script&lang=js"
export * from "./epmallcart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports